import type { AuthUser } from '@/shared/lib/auth/auth-provider'
import type { PermissionCheck } from './permission-values'
import { LEGACY_PERMISSION_ALIASES, PermissionLevel } from './permission-values'

export function canAccess(
  user: AuthUser | null,
  check: PermissionCheck | null | undefined,
): boolean {
  if (!user) return false

  // Fail-closed on invalid checks. The legacy Angular *hasRole directive
  // treated an empty check as "allow", which silently exposed admin pages.
  if (!check || !check.name || check.level === undefined || check.level === null) {
    return false
  }

  // SuperAdmin bypasses any valid permission check (invalid checks above
  // already returned false — an empty/malformed check is never "allow").
  if (user.isSuperAdmin) return true

  // A split key (CU-91.1) the user does not carry yet falls back to its legacy
  // alias; once the split key is present it decides, even below the legacy level.
  const legacyName = LEGACY_PERMISSION_ALIASES[check.name]
  const userLevel =
    user.permissions[check.name] ?? (legacyName === undefined ? undefined : user.permissions[legacyName])
  if (userLevel === undefined) return false

  return userLevel >= check.level
}

export function hasMinLevel(
  user: AuthUser | null,
  permissionName: string,
  requiredLevel: number = PermissionLevel.Read,
): boolean {
  return canAccess(user, { name: permissionName, level: requiredLevel as PermissionLevel })
}
